export  enum DepartmentBookingType {
    AED = 1,
    OtherDepartment = 2,
    Breakdown = 3
}


